
{
  "fr": {
    "title": "Sélection du point relais DPD",
    "relay-modal-submit": "Sélectionner ce point relais",
    "tab-relays-list": "Liste des relais",
    "tab-map": "Carte"
  }
}
